import ApiClient from './ApiClient';

class CampaignsContactListAPI extends ApiClient {
  constructor() {
    super('campaign_contact_lists', { accountScoped: true });
  }

  async getAll(){
    return await axios.get(this.url);
  }
  async getAllContacts(){
    return await axios.get(`${this.url}/show_all_contacts`);
  }
  async getById(id){
    return await axios.get(`${this.url}/${id}`);
  }

  async update(payload){
    const { id } = payload.campaign_contact_list;
    return await axios.put(`${this.url}/${id}`, payload);
  }
  async deleteList(id){
    return await axios.delete(`${this.url}/${id}`);
  }

  async createList(payload){
    return await axios.post(this.url, payload);
  }
}

export default new CampaignsContactListAPI();
